var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-navbar',{attrs:{"square":"","center-collapsed":"","shadow":""}},[_c('vs-navbar-item',{staticClass:"solid"},[_c('img',{attrs:{"src":"https://www.kuntokruunu.fi/wp-content/uploads/2020/07/LOGO.png","alt":"logo"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }